<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/work/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wenjianmingcheng')">
            <el-input v-model="yt.conditions.fileName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
          </el-form-item>
          <!-- 		<el-form-item :label="$t('caozuoshijian')">
						<yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime"
							:end.sync="yt.conditions.endTime">
						</yi_time_input>
					</el-form-item> -->
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 顶部插槽2 -->
      <template #top2>
        <div style="background: #F7F8FA;height: 28px;width: 100%;display: flex; justify-content: space-between; flex-wrap: nowrap; align-items: center;margin-top: 20px;">
          <div style="color: #419FFF;">{{ $t('xiazaiwenjian') }}</div>
        </div>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <!-- 	<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary" v-if="ids == null">
					{{$t('xinzeng')}}
				</el-button> -->
      </template>
      <!-- 查询条件 -->
      <!-- <template #chaxuntiaojian="scope">
				{{ (scope.row.remark == '' || scope.row.remark == null) ? '-' : scope.row.remark }}
			</template> -->
      <!-- 备注 -->
      <template #beizhu="scope">
        {{ scope.row.info == '' || scope.row.info == null ? '-' : scope.row.info }}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <template v-if="scope.row.status == -1">
          <el-button :loading="yt.editObj.loading" @click="retry(scope.row.id)" type="text">{{ $t('chongshi') }}</el-button>
        </template>
        <template v-else-if="scope.row.status == 0"> </template>
        <template v-else="scope.row.status == 1">
          <!-- {{scope.row}} -->
          <el-button :loading="yt.editObj.loading" @click="downFile(scope.row.fileId)" type="text">{{ $t('xiazai') }}</el-button>
        </template>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('caidanleixing')" required="required">
            <yi_dictionary_select :type="'PARAMETER_TYPE'" :ids.sync="yt.editObj.typeId"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('canshubianma')" required="required">
            <el-input v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('canshumingcheng')" required="required">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhi')" required="required">
            <el-input v-model="yt.editObj.value"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.req('POST', '/web/config/parameter/create', null, fetchData)" type="primary">{{ $t('queren') }} </el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('caidanleixing')">
            <yi_dictionary_select disabled :type="'PARAMETER_TYPE'" :ids.sync="yt.editObj.typeId"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('canshubianma')">
            <el-input disabled v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('canshumingcheng')">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhi')">
            <el-input v-model="yt.editObj.value"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.req('POST', '/web/config/parameter/update', null, fetchData)" type="primary">{{ $t('queren') }} </el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_export_list',

  data() {
    return {
      columns: [
        {
          label: 'renwumingcheng',
          prop: 'workName',
          width: 150
        },
        {
          label: 'wenjianmingcheng',
          prop: 'fileName',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm'
        },
        {
          label: 'wanchengshijian',
          prop: 'updateTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm'
        },
        // {
        // 	label: 'chaxuntiaojian',
        // 	prop: 'info',
        // 	type: 'slot',
        // },
        {
          label: 'beizhu',
          prop: 'remark',
          type: 'slot'
        },
        {
          label: 'renwuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            '0': {
              color: '#419FFF',
              text: this.$t('jinxingzhong')
            },
            '-1': {
              color: '#F56C6C',
              text: this.$t('shibai')
            },
            '1': {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            }
          }
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 100,
          fixed: 'right'
        }
      ]
    };
  },

  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 下载文件
    async downFile(id) {
      console.log('ffff', id);
      let response = await this.http.get('/web/customer/files/download?id=' + id).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    //重试
    async retry(id) {
      let response = await this.http.get('/web/report/work/reset?id=' + id).then(res => {
        this.yt.get(1);
      });
    }
  }
};
</script>
